// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2KYGy","calendarButtons":"ClockData_calendarButtons__1hNGX"};